// The value rule of the backend (`lims-be` `import-value-rules.ts`), applied
// again by the summary step after every edit.

// Written instead of a value below the LD threshold.
export const BELOW_LOD_VALUE = '< LOD';

// §2 (C18): a number with an optional sign and exponent, the decimal comma
// read as a dot. Anything else (`N/A`, `104.8%`, `<0.01`, thousands
// separators) is not a number.
const NUMBER_PATTERN = /^[+-]?(\d+([.,]\d*)?|[.,]\d+)([eE][+-]?\d+)?$/;

// The number written in `text`, null when it is not one.
export function parseCellNumber(text) {
  if (text === null || text === undefined) return null;
  const trimmed = String(text).trim();
  if (!NUMBER_PATTERN.test(trimmed)) return null;
  const value = Number(trimmed.replace(',', '.'));
  return Number.isFinite(value) ? value : null;
}

// Half away from zero on the decimal value (C33). Shifting through the
// exponent avoids the binary error of `x * 10 ** d`: `1.005` → `1.01`.
export function roundHalfAwayFromZero(value, decimals) {
  const [mantissa, exponent] = Math.abs(value).toExponential().split('e');
  const shifted = Math.round(
    Number(`${mantissa}e${Number(exponent) + decimals}`)
  );
  return Math.sign(value) * Number(`${shifted}e-${decimals}`);
}

// REQ-10: below the threshold `< LOD` with LD = threshold, verbatim;
// otherwise the value at fixed decimals with an empty LD. The two never split.
export function applyValueRule(value, ldThreshold, decimals) {
  if (value < Number(ldThreshold)) {
    return { value: BELOW_LOD_VALUE, LD: ldThreshold };
  }
  return {
    value: roundHalfAwayFromZero(value, decimals).toFixed(decimals),
    LD: '',
  };
}
